import * as Preact from "preact"

import Navigation from "@fae/source/engine/navigating/Navigation.js"
// import preload from "@fae/source/data/preload.js"
import games from "@fae/source/data/games"

export default function TitleSplashScreen() {
    // if(preload.isLoading) {
    //     return <LoadingScreen/>
    // }
    return (
        <div class="TitleScreen">
            <title>{games[Navigation.state.gameSlug].title}</title>
            <div class="Main">
                {this.props.children}
                <div class="DevHellButton" onClick={() => Navigation.go("/dev")}>Dev Hell</div>
                <div class="ProductionButton" onClick={() => window.location.search = "/production/"}>Production</div>
            </div>
            <div class="Splash" isSplashing={Navigation.state.isSplashing + ""}
                onClick={() => Navigation.state.isSplashing = false}>
                <div class="Logo1">Goodberry Games</div>
                <div class="Logo2">
                    <div>Made with NO AI</div>
                </div>
            </div>
        </div>
    )
}
